import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Respuesta, Atributo } from '../_models/shared/_index';
import { ValorAtributo } from '../_models/shared/valor-atributo';
import { ErrorService } from './error.service';
import { ConfiguracionArbolAtributos } from '../components/arbol-lazy/models/configuracionArbolAtributos';
import { ReglaAtributo } from '../_models/shared/regla-atributo';
import { CondicionReglaAtributo } from '../_models/shared/condicion-regla-atributo';
@Injectable()
export class AtributosService {
	private getAtributosUrl = environment.rest + '/Atributos/GetAtributos';
	private getAtributoPadreUrl =
		environment.rest + '/Atributos/GetAtributoPadre';

	private getHijosUrl = environment.rest + '/Atributos/GetHijos';
	private getUnidadesUrl = environment.rest + '/Atributos/GetUnidades';

	private editarAtributoUrl = environment.rest + '/Atributos/EditarAtributo';
	private agregarAtributoUrl = environment.rest + '/Atributos/AgregarAtributo';
	private eliminarAtributoUrl =
		environment.rest + '/Atributos/EliminarAtributos';

	private moverAtributoUrl = environment.rest + '/Atributos/MoverAtributo';

	private getAtributosVentajasUrl =
		environment.rest + '/Atributos/GetAtributosComparacion';
	private getOrdenAtributosAsignablesVersionParcialUrl =
		environment.rest + '/Atributos/GetOrdenAtributosAsignablesVersionParcial';

	private getValoresAtributoUrl =
		environment.rest + '/Atributos/GetValoresAtributo';
	private addValoresAtributoUrl =
		environment.rest + '/Atributos/AddValoresAtributo';
	private editValoresAtributoUrl =
		environment.rest + '/Atributos/EditValoresAtributo';
	private delValoresAtributoUrl =
		environment.rest + '/Atributos/DelValoresAtributo';

	private getAtributosAsignablesUrl =
		environment.rest + '/Atributos/GetAtributosAsignables';

	private generarMatrizDeAtributosUrl =
		environment.rest + '/Atributos/GenerarMatrizDeAtributos';
	private validaYCargaMasivaAtributosUrl =
		environment.rest + '/Atributos/ValidaYCargaMasivaAtributos';

	private getAtributosExtraccionDatosUrl =
		environment.rest + '/Atributos/GetAtributosExtraccionDatos';

	private getValoresAtributoMultipleWhUrl =
		environment.rest + '/Atributos/GetValoresAtributoMultipleWh';
	private getValoresAtributoNumericoWhUrl =
		environment.rest + '/Atributos/getValoresAtributoNumericoWh';

	private getIdAtributoRaizRSUrl =
		environment.rest + '/Atributos/GetIdAtributoRaizRS';

	private getArbolAtributosUrl =
		environment.rest + '/Atributos/GetArbolAtributos';

	private addReglaAtributoUrl =
		environment.rest + '/Atributos/AddReglaAtributo';

	private editReglaAtributoUrl =
		environment.rest + '/Atributos/EditReglaAtributo';

	private delReglaAtributoUrl =
		environment.rest + '/Atributos/DelReglaAtributo';

	private getReglasAtributoUrl =
		environment.rest + '/Atributos/GetReglasAtributo';

	private delCondicionReglaAtributoUrl =
		environment.rest + '/Atributos/DelCondicionReglaAtributo';

	private getAtributoByIdUrl =
		environment.rest + '/Atributos/GetAtributoById';

	private getIdsAtributosByIdsVersionesUrl =
		environment.rest + '/Atributos/GetIdsAtributosByIdsVersiones';

	private getValoresAtributoByVersionUrl =
		environment.rest + '/Atributos/GetValoresAtributoByVersion';

	private getNodoAtributoByCodigoUrl =
		environment.rest + '/Atributos/GetNodoAtributoByCodigo';

	private getAtributosPlacaVariableLocalUrl =
		environment.rest + '/Atributos/GetAtributosPlacaVariableLocal';

	private guardarAtributosPlacaVariableLocalUrl =
		environment.rest + '/Atributos/GuardarAtributosPlacaVariableLocal';

	private getDescripcionAtributoUrl =
		environment.rest + '/Atributos/GetDescripcionAtributo';

	private getTipoAtributoUrl =
		environment.rest + '/Atributos/GetTipoAtributo';

	constructor(private http: HttpClient, private errorService: ErrorService) { }

	headers = new HttpHeaders({ 'Content-Type': 'application/json' });
	options = { headers: this.headers, withCredentials: true };

	public getAtributoPadre(): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getAtributoPadreUrl, {}, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post getAtributoPadre`)
				)
			);
	}

	public getAtributos(idArbolRs: number = -1): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getAtributosUrl, { idArbolRs }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(this.errorService.handleError<Respuesta>(`get getAtributos`))
			);
	}

	public getIdAtributoRaizRS(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getIdAtributoRaizRSUrl, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`get getIdAtributoRaizRS`)
				)
			);
	}

	public getAtributosAsignables(
		soloParaVersionesParciales: boolean
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.getAtributosAsignablesUrl,
				{ soloParaVersionesParciales },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`POST getAtributosAsignables`
					)
				)
			);
	}

	public getHijos(
		padre: Atributo,
		excluir: number[] = [],
		incValores: boolean = false
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.getHijosUrl,
				{ padre, incValores, excluir },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get hijos idAtributo=${padre.idAtributo}`
					)
				)
			);
	}

	public getUnidades(): Observable<Respuesta> {
		return this.http.get<Respuesta>(this.getUnidadesUrl, this.options).pipe(
			tap((res) => {
				this.errorService.CheckResponse(res);
			}),
			catchError(this.errorService.handleError<Respuesta>(`get getUnidades`))
		);
	}

	public editarAtributo(atributo: Atributo): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.editarAtributoUrl, { atributo }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post editarAtributo`)
				)
			);
	}

	public agregarAtributo(atributo: Atributo): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.agregarAtributoUrl, { atributo }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post agregarAtributo`)
				)
			);
	}

	public eliminarAtributo(atributo: Atributo): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.eliminarAtributoUrl, { atributo }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post eliminarAtributo`)
				)
			);
	}

	public moverAtributo(
		idAtributo: number,
		idNuevaCategoria: number
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.moverAtributoUrl,
				{ idAtributo, idNuevaCategoria },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post moverAtributo`)
				)
			);
	}

	public getAtributosVentajas(idVersion: number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.getAtributosVentajasUrl,
				{ idVersion },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post getAtributosVentajas`)
				)
			);
	}

	public getOrdenAtributosAsignablesVersionParcial(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(
				this.getOrdenAtributosAsignablesVersionParcialUrl,
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getOrdenAtributosAsignablesVersionParcial`
					)
				)
			);
	}

	public getValoresAtributo(idAtributo: number): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getValoresAtributoUrl, { idAtributo }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post getValoresAtributo`)
				)
			);
	}
	public addValoresAtributo(
		valorAtributo: ValorAtributo
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.addValoresAtributoUrl,
				{ valorAtributo },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post addValoresAtributo`)
				)
			);
	}
	public editValoresAtributo(
		valorAtributo: ValorAtributo
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.editValoresAtributoUrl,
				{ valorAtributo },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post editValoresAtributo`)
				)
			);
	}
	public delValoresAtributo(
		valorAtributo: ValorAtributo
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.delValoresAtributoUrl,
				{ valorAtributo },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post delValoresAtributo`)
				)
			);
	}

	public generarMatrizDeAtributos(
		idModelo: number,
		idsVersiones: number[],
		inclDiscont: boolean
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.generarMatrizDeAtributosUrl,
				{ idModelo, idsVersiones, inclDiscont },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post generarMatrizDeAtributos`
					)
				)
			);
	}

	public validaYCargaMasivaAtributos(
		idModelo: number,
		urlArchivo: string
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.validaYCargaMasivaAtributosUrl,
				{ idModelo, urlArchivo },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post validaYCargaMasivaAtributos`
					)
				)
			);
	}

	public getAtributosExtraccionDatos(
		inclValores: boolean
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.getAtributosExtraccionDatosUrl,
				{ inclValores },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getAtributosExtraccionDatos`
					)
				)
			);
	}

	public getValoresAtributoNumericoWh(codigo: string): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(
				this.getValoresAtributoNumericoWhUrl + '?codigoAtributo=' + codigo,
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(this.errorService.handleError<Respuesta>(`get getAtributos`))
			);
	}

	public getValoresAtributoMultipleWh(codigo: string): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(
				this.getValoresAtributoMultipleWhUrl + '?codigoAtributo=' + codigo,
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(this.errorService.handleError<Respuesta>(`get getAtributos`))
			);
	}

	public getArbolDeAtributos(
		config: ConfiguracionArbolAtributos
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getArbolAtributosUrl, { config }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getAtributosExtraccionDatos`
					)
				)
			);
	}

	public addReglaAtributo(
		reglaAtributo: ReglaAtributo
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.addReglaAtributoUrl,
				{ reglaAtributo },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post addReglaAtributo`)
				)
			);
	}

	public editReglaAtributo(
		reglaAtributo: ReglaAtributo
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.editReglaAtributoUrl,
				{ reglaAtributo },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post editReglaAtributo`)
				)
			);
	}

	public delReglaAtributo(
		reglaAtributo: ReglaAtributo
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.delReglaAtributoUrl,
				{ reglaAtributo },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post delReglaAtributo`)
				)
			);
	}

	public getReglasAtributo(
		idAtributo: number
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getReglasAtributoUrl, { idAtributo }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getReglasAtributos`
					)
				)
			);
	}

	public delCondicionReglaAtributo(
		condicionReglaAtributo: CondicionReglaAtributo
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(
				this.delCondicionReglaAtributoUrl,
				{ condicionReglaAtributo },
				this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(`post delCondicionReglaAtributo`)
				)
			);
	}

	public getAtributoById(
		idAtributo: number,
		incluirValores: boolean = true,
		incluirHijos: boolean = true
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getAtributoByIdUrl, { idAtributo, incluirValores, incluirHijos }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getAtributoById`
					)
				)
			);
	}

	public getIdsAtributosByIdsVersiones(
		idsVersiones: number[]
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getIdsAtributosByIdsVersionesUrl, { idsVersiones }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getIdsAtributosByIdsVersiones`
					)
				)
			);
	}

	public getValoresAtributoByVersion(
		idsVersiones: number[],
		idsAtributos: number[],
		columna: string,
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getValoresAtributoByVersionUrl, { idsVersiones, idsAtributos, columna }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getValoresAtributoByVersion`
					)
				)
			);
	}

	public getNodoAtributoByCodigo(codigo: string): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getNodoAtributoByCodigoUrl, { codigo }, this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getNodoAtributoByCodigo`
					)
				)
			);
	}

	public getAtributosPlacaVariableLocal(): Observable<Respuesta> {
		return this.http
			.get<Respuesta>(this.getAtributosPlacaVariableLocalUrl, this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get getAtributosPlacaVariableLocal`
					)
				)
			);
	}

	public guardarAtributosPlacaVariableLocal(atributos): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.guardarAtributosPlacaVariableLocalUrl, { atributos }, this.options
			)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`get guardarAtributosPlacaVariableLocal`
					)
				)
			);
	}

	public getDescripcionAtributo(
		idAtributo: number,
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getDescripcionAtributoUrl, { idAtributo }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getDescripcionAtributo`
					)
				)
			);
	}

	public getTipoAtributo(
		idAtributo: number,
	): Observable<Respuesta> {
		return this.http
			.post<Respuesta>(this.getTipoAtributoUrl, { idAtributo }, this.options)
			.pipe(
				tap((res) => {
					this.errorService.CheckResponse(res);
				}),
				catchError(
					this.errorService.handleError<Respuesta>(
						`post getTipoAtributo`
					)
				)
			);
	}
}
